import React from 'react';

const SvgSprite = ({iconId = "arrow-circle", className}) => {
    const spriteUrl = window.__litium?.constants?.spriteUrl;

    return (
    <svg className={className}>
        <use href={`${spriteUrl}#${iconId}`} />
    </svg>)
}

export default SvgSprite;